module.exports = __webpack_public_path__ + "static/media/logo-grey5.9bb3c6bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-grey5.svg
// module id = 1120
// module chunks = 0